import * as React from "react";
import Skeleton from "@mui/lab/Skeleton";
import { styled } from "@mui/material";

//region [[ Styles ]]

const SkeletonLoaderView = styled("div")({
  display: "flex",
  flexDirection: "column",
  gap: 4,
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface SkeletonLoaderProps {
  style?: React.CSSProperties;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const SkeletonLoader = ({ ...props }: SkeletonLoaderProps) => {
  return (
    <SkeletonLoaderView style={props.style} className={"skeleton-loader"}>
      <Skeleton variant="text" width={"60%"} />
      <Skeleton variant="text" width={"40%"} />
      <Skeleton variant="text" width={"80%"} />
      <Skeleton variant="text" width={"30%"} />
    </SkeletonLoaderView>
  );
};
